import { PortalError } from './PortalError';

export class ObjectNotFoundError extends PortalError {
  constructor(objectName: string) {
    super('ObjectNotFoundError', `${objectName} not found`);
  }
}
